"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SparklineWithCaption = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const Sparkline_1 = require("../widgets/sparkline/Sparkline");
const ViewerPaneStyles_1 = require("./ViewerPaneStyles");
const SparklineCaption = (0, vizportalclient_common_components_1.divWithStyle)('sparkline-caption', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Small,
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
    textAlign: 'right',
});
const sparklineWidth = ViewerPaneStyles_1.dataDetailsContentWidth;
const sparklineHeight = 66;
/**
 * A wrapper around the Sparkline component that adds a caption below.
 */
class SparklineWithCaption extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Sparkline_1.Sparkline, { width: sparklineWidth, height: sparklineHeight, dataPoints: this.props.dataPoints, title: this.props.caption }),
            react_1.default.createElement(SparklineCaption, { style: { width: sparklineWidth } }, this.props.caption)));
    }
}
exports.SparklineWithCaption = SparklineWithCaption;
//# sourceMappingURL=SparklineWithCaption.js.map